import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gridGap: 18,
  backgroundColor: '#FAFAFB'
});
